var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Rating',_vm._g(_vm._b({scopedSlots:_vm._u([{key:"star",fn:function(ref){
var active = ref.active;
return [_c('span',{staticStyle:{"font-size":"10px"},style:(!active ? 'filter: grayscale(1)' : '')},[_vm._v("🔥")])]}}])},'Rating',_vm.$props,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }